export interface PaymentPartnerFormUi {
  email: string;
}

export const emptyPaymentPartnerForm = (): PaymentPartnerFormUi => ({
  email: '',
});
